export default __webpack_public_path__ + "static/media/logoInfraestructura.f957dd9b.png";